import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/inherits";
import { TokenType as tt } from "../parser/tokenizer/types";
import Transformer from "./Transformer";

var NumericSeparatorTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inherits(NumericSeparatorTransformer, _Transformer);

  function NumericSeparatorTransformer(tokens) {
    var _this;

    _classCallCheck(this, NumericSeparatorTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumericSeparatorTransformer).call(this));
    _this.tokens = tokens;
    ;
    return _this;
  }

  _createClass(NumericSeparatorTransformer, [{
    key: "process",
    value: function process() {
      if (this.tokens.matches1(tt.num)) {
        var code = this.tokens.currentTokenCode();

        if (code.includes("_")) {
          this.tokens.replaceToken(code.replace(/_/g, ""));
          return true;
        }
      }

      return false;
    }
  }]);

  return NumericSeparatorTransformer;
}(Transformer);

export { NumericSeparatorTransformer as default };